import type { QueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { publicMemberKeys } from '../publicMember/keys';
import { getQuickMoveMemberLookupId, resolveQuickMoveEligibility, ResolveQuickMoveEligibilityInput } from './eligibility';

/** 드래그 시작 시 최신 회원 캐시만 읽는다. 조회 요청·회원별 query observer를 만들지 않는다. */
export const resolveQuickMoveCachedEligibility = ({
    queryClient, centerId, ...input
}: Omit<ResolveQuickMoveEligibilityInput, 'memberAccount'> & { queryClient: QueryClient; centerId: string }) => {
    const memberId = getQuickMoveMemberLookupId(input.event);
    if (!memberId) return resolveQuickMoveEligibility(input);
    const state = queryClient.getQueryState<any>(publicMemberKeys.detail(centerId, memberId));
    const raw = state?.data?.data;
    return resolveQuickMoveEligibility({
        ...input,
        memberAccount: {
            isLoading: !state || state.status === 'loading',
            isError: state?.status === 'error' || !raw,
            // usePublicMemberDetail의 회원 상태 병합 계약과 같다.
            centerMember: raw ? {
                ...raw.centerMember,
                appAccountStatus: raw.centerMember?.appAccountStatus ?? raw.member?.appAccountStatus,
                appWithdrawnAt: raw.centerMember?.appWithdrawnAt ?? raw.member?.appWithdrawnAt,
            } : undefined,
        },
    });
};

/** 메뉴·기존 상세 등 어떤 경로가 캐시를 채워도 카드의 터치 설정을 다시 평가한다. 요청은 만들지 않는다. */
export const useQuickMoveMemberCacheRevision = ({ queryClient, centerId }: { queryClient: QueryClient; centerId: string }) => {
    const [revision, setRevision] = useState(0);
    useEffect(() => queryClient.getQueryCache().subscribe((event) => {
        if (event.type !== 'updated') return;
        const key = event.query.queryKey;
        if (key[0] === publicMemberKeys.all[0] && key[1] === 'detail' && key[2] === centerId) {
            setRevision((current) => current + 1);
        }
    }), [centerId, queryClient]);
    return revision;
};
